(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-aris-hero]';

    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;

      const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      const previous = root.querySelector('[data-hero-prev]');
      const next = root.querySelector('[data-hero-next]');
      const pause = root.querySelector('[data-hero-pause]');

      root.dataset.initialized = 'true';

      if (slides.length < 2) return;

      let activeIndex = Math.max(
        0,
        slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      let timer = null;
      let pausedByUser = false;
      let pointerStart = null;

      const autoplayEnabled =
        root.dataset.autoplay === 'true' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = Math.max(3000, Number(root.dataset.interval) || 6000);

      const render = (nextIndex, userInitiated = false) => {
        activeIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach((dot, index) => {
          const active = index === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (userInitiated) restart();
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        if (!autoplayEnabled || pausedByUser || document.hidden) return;
        timer = window.setInterval(() => render(activeIndex + 1), interval);
      };

      const restart = () => {
        stop();
        start();
      };

      previous?.addEventListener('click', () => render(activeIndex - 1, true));
      next?.addEventListener('click', () => render(activeIndex + 1, true));

      dots.forEach((dot) => {
        dot.addEventListener('click', () => render(Number(dot.dataset.index), true));
      });

      pause?.addEventListener('click', () => {
        pausedByUser = !pausedByUser;
        pause.classList.toggle('is-paused', pausedByUser);
        pause.setAttribute(
          'aria-label',
          pausedByUser ? 'Pornește redarea automată' : 'Oprește redarea automată'
        );
        pausedByUser ? stop() : start();
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) start();
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') render(activeIndex - 1, true);
        if (event.key === 'ArrowRight') render(activeIndex + 1, true);
      });

      root.addEventListener('pointerdown', (event) => {
        pointerStart = { x: event.clientX, y: event.clientY };
      });

      root.addEventListener('pointerup', (event) => {
        if (!pointerStart) return;
        const distanceX = event.clientX - pointerStart.x;
        const distanceY = event.clientY - pointerStart.y;
        pointerStart = null;

        if (Math.abs(distanceX) < 45 || Math.abs(distanceX) < Math.abs(distanceY)) return;
        render(activeIndex + (distanceX < 0 ? 1 : -1), true);
      });

      document.addEventListener('visibilitychange', () => {
        document.hidden ? stop() : start();
      });

      render(activeIndex);
      start();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialize);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.storyInitialized === 'true') return;
      root.dataset.storyInitialized = 'true';

      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(root);
    };

    document.querySelectorAll('[data-aris-story]').forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-aris-story]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
